import $ from 'jquery'
import 'jquery-ui/ui/widgets/autocomplete';

document.addEventListener("DOMContentLoaded", function (dom) {
    const dropdown = document.querySelector('.js-category-select');

    dropdown?.addEventListener('change', (event) => {
        window.location.href = event.target.value;
    });

    const object = vnObject

    const search = $('.js-blog-search-input')
    if (search.length) {
        search.each(function () {
            const cur = $(this)
            const parent = cur.parents('.js-filters')
            const appendTo = parent.attr('data-append')
                ? parent.find(`.${parent.attr('data-append')}`)
                : null
            cur
                .autocomplete({
                    appendTo,
                    minLength: 3,
                    source: function (request, response) {
                        $.ajax({
                            url: object.ajaxUrl,
                            type: 'POST',
                            dataType: 'JSON',
                            data: {
                                nonce: object.nonce,
                                action: 'vn_get_posts',
                                keyword: request.term,
                                postType: parent.attr('data-post-types'),
                            },
                            success: function (res) {
                                response(res.data.data)
                            },
                        })
                    },
                    search: function (event) {
                        $(event.target)
                            .parents('.js-filters')
                            .addClass('pt-posts__filters--searching')
                    },
                    open: function (event) {
                        $(event.target)
                            .parents('.js-filters')
                            .addClass('pt-posts__filters--active')
                        $(event.target).addClass('autocomplete-active')
                    },
                    close: function (event) {
                        $(event.target)
                            .parents('.js-filters')
                            .removeClass('pt-posts__filters--active')
                        $(event.target).removeClass('autocomplete-active')
                    },
                    response: function (event) {
                        $(event.target)
                            .parents('.js-filters')
                            .removeClass('pt-posts__filters--searching')
                    },
                    create: function () {
                        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                            return $('<li>')
                                .append(
                                    `<a href="${item.url}" class="res-class">${
                                        item.thumbnail
                                            ? `<img src="${item.thumbnail}" alt="${item.name}">`
                                            : ''
                                    }${item.title}</a>`
                                )
                                .appendTo(ul)
                        }
                    },
                })
                .focus(function () {
                    $(this).data('uiAutocomplete').search($(this).val())
                })
        })
    }

});
